import { 
    FETCH_SALESPARTNER_STARTED, 
    FETCH_SALESPARTNER_FAILED,
    FETCH_SALESPARTNER_SUCCEEDED,
    FETCH_SALESPARTNER_LOGIN_SUCCEEDED
} from '../actions/types';

import errorHandler from '../actions/errorHandler';

export const INITIAL_STATE = {
  data: JSON.parse(localStorage.getItem('salespartner')),
  error: {}
};


export default function(state=INITIAL_STATE, action){
    switch(action.type){
        case FETCH_SALESPARTNER_STARTED:
            return {...state, data: null, error: {} };
        case FETCH_SALESPARTNER_LOGIN_SUCCEEDED:
            return {...state, data: action.payload.data.salespartner, error: {} };
        case FETCH_SALESPARTNER_SUCCEEDED:
            return {...state, data: action.payload.data, error: {} };
        case FETCH_SALESPARTNER_FAILED: {
            const errorObj = errorHandler(action.payload);
            return {...state, error: errorObj, data: null };
        }
        default:
            return state;
    }
}